import axiosInstance from "./axios.config";

export async function getSeasonLeaderBoard(seasonId) {
  try {
    const response = await axiosInstance.get(
      `/dashboard/season-leaderboard/${seasonId}`
    );

    return response.data;
  } catch (error) {
    throw error;
  }
}
export async function updateStockSelection(
  selection_id,
  season_id,
  selected_week,
  day_of_week,
  stock_symbol,
  user_id
) {
  try {
    const response = await axiosInstance.post("/stocks/stock-selection", {
      selection_id,
      season_id,
      selected_week,
      day_of_week,
      stock_symbol,
      user_id
    });

    return response.data;
  } catch (error) {
    console.log("error from updateStockSelection === ", error?.response?.data?.message);
    throw error?.response?.data?.message;
  }
}
